import createCachedSelector, { LruObjectCache } from 're-reselect';

import { getUserFirstName, getUserLastName } from 'selectors/user/selector';

/* ***************************************** */
// Return a color based on the string and within a list of available colors
// Pros: each user will always have the same color associated.

const COLORS = [
  '#616161',
  '#8D0E0E',
  '#7F3E84',
  '#0A7095',
  '#2D6D30',
  '#B85C00',
  '#455B6E',
  '#0A3877',
  '#000000',
  '#0000FF',
  '#006401',
  '#010067',
  '#95003A',
  '#007DB5',
  '#774D00',
  '#7A4782',
  '#7E2DD2',
  '#A42400',
  '#263400',
  '#9E008E',
  '#001544',
  '#004754',
  '#0E4CA1',
  '#620E00',
  '#7544B1',
  '#B500FF',
  '#005F39',
  '#6B6882',
  '#A75740'
];

function colorForText(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash += str.charCodeAt(i);
  }

  let color;
  if (hash < COLORS.length) {
    color = COLORS[hash];
  } else {
    color = COLORS[hash % COLORS.length];
  }
  return color;
}

const getColorForName = createCachedSelector(getUserFirstName, getUserLastName, (firstName, lastName) => colorForText(`${firstName} ${lastName}`))(
  props => `getColorForName:${props.user.email}`,
  {
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  }
);

function clearAllCache() {
  getColorForName.clearCache();
}

export default getColorForName;

export { clearAllCache, getColorForName };
